const loaded = ['AkkuratLL'];
export const loadFont = (family: string) => {
  if (!family) return;
  if (loaded.includes(family)) return;
  const headID = document.getElementsByTagName('head')[0];
  const link = document.createElement('link');
  link.type = 'text/css';
  link.rel = 'stylesheet';
  headID.appendChild(link);
  link.href = 'https://fonts.googleapis.com/css?family=' + family.split(' ').join('+') + ':wght@400;700;900';
  loaded.push(family);
};
